import {createAction, props} from '@ngrx/store';

export const setNonce = createAction(
    '[Auth] Nonce',
    props<{ nonce: string }>()
);
